import type { PromotionDetails } from '@frontend/api-types';
import { normalizePromoCode } from './normalizePromoCode';

export type ValidatedPromoInput = {
  promoCode: string;
  promotionId?: string;
};

export type PricingState = 'error' | 'initialLoading' | 'ready' | 'transitioning';

export const getValidatedPromoInput = ({
  promoCode,
  promotionId,
}: {
  promoCode?: string;
  promotionId?: MaybeNull<PromotionDetails['promotionId']>;
}): ValidatedPromoInput | undefined => {
  const normalizedPromoCode = normalizePromoCode(promoCode);

  if (!normalizedPromoCode) {
    return undefined;
  }

  return {
    promoCode: normalizedPromoCode,
    promotionId: promotionId ?? undefined,
  };
};
